import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { BaseButtonView } from './BaseButtonView';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { Color } from '../../../Helpers';
export const SecondaryButtonView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.secondaryButton,
    style(theme, mediaQuery, window, props) {
        var _a;
        const containerBorderColor = ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.primary_color) || 'rgb(219, 0, 125)';
        const rgb = containerBorderColor
            .replace('rgb(', '')
            .replace('rgba(', '')
            .replace(')', '')
            .replace(' ', '')
            .split(',')
            .map(Number);
        const pressBackgroundColor = new Color(rgb[0], rgb[1], rgb[2])
            .brightness(0.6)
            .toString();
        return {
            container: {
                backgroundColor: 'rgba(255, 255, 255, 0)',
                borderColor: containerBorderColor,
                borderWidth: 1
            },
            hover: {
                backgroundColor: containerBorderColor
            },
            pressed: {
                backgroundColor: pressBackgroundColor
            },
            inactive: {
                borderColor: 'rgba(184, 189, 199, 1)'
            },
            inactiveText: {
                color: 'rgba(184, 189, 199, 1)'
            },
            disabled: {
                opacity: 0.4
            },
            rounded: {
                backgroundColor: 'rgba(255, 255, 255, 1)'
            },
            pressedRounded: {
                backgroundColor: 'rgba(226, 226, 226, 1)'
            },
            hoverRounded: {
                backgroundColor: 'rgba(233, 233, 233, 1)'
            },
            text: {
                color: containerBorderColor
            },
            hoverText: {
                color: '#fff'
            },
            pressedText: {
                color: '#fff'
            },
            roundedText: {
                color: '#DB007D'
            }
        };
    }
})((props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    const [isHovered, setIsHovered] = useState(false);
    function onHover() {
        setIsHovered(true);
    }
    function onBlur() {
        setIsHovered(false);
    }
    function getBGColors() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        if (props.rounded) {
            return {
                defaultBackground: props.fullColored
                    ? props.defaultBackground || ((_b = (_a = props.style) === null || _a === void 0 ? void 0 : _a.rounded) === null || _b === void 0 ? void 0 : _b.backgroundColor)
                    : (_d = (_c = props.style) === null || _c === void 0 ? void 0 : _c.rounded) === null || _d === void 0 ? void 0 : _d.backgroundColor,
                hoverBackground: props.hoverBackground || ((_f = (_e = props.style) === null || _e === void 0 ? void 0 : _e.hoverRounded) === null || _f === void 0 ? void 0 : _f.backgroundColor),
                pressBackground: props.pressBackground || ((_h = (_g = props.style) === null || _g === void 0 ? void 0 : _g.pressedRounded) === null || _h === void 0 ? void 0 : _h.backgroundColor),
                inactiveBackground: props.inactiveBackground || ((_k = (_j = props.style) === null || _j === void 0 ? void 0 : _j.inactive) === null || _k === void 0 ? void 0 : _k.backgroundColor),
                disableBackground: props.disableBackground || ((_m = (_l = props.style) === null || _l === void 0 ? void 0 : _l.disabled) === null || _m === void 0 ? void 0 : _m.backgroundColor)
            };
        }
        return {
            defaultBackground: props.fullColored
                ? props.defaultBackground || ((_p = (_o = props.style) === null || _o === void 0 ? void 0 : _o.container) === null || _p === void 0 ? void 0 : _p.backgroundColor)
                : (_r = (_q = props.style) === null || _q === void 0 ? void 0 : _q.container) === null || _r === void 0 ? void 0 : _r.backgroundColor,
            hoverBackground: props.hoverBackground || ((_t = (_s = props.style) === null || _s === void 0 ? void 0 : _s.hover) === null || _t === void 0 ? void 0 : _t.backgroundColor),
            pressBackground: props.pressBackground || ((_v = (_u = props.style) === null || _u === void 0 ? void 0 : _u.pressed) === null || _v === void 0 ? void 0 : _v.backgroundColor),
            inactiveBackground: props.inactiveBackground || ((_x = (_w = props.style) === null || _w === void 0 ? void 0 : _w.inactive) === null || _x === void 0 ? void 0 : _x.backgroundColor),
            disableBackground: props.disableBackground || ((_z = (_y = props.style) === null || _y === void 0 ? void 0 : _y.disabled) === null || _z === void 0 ? void 0 : _z.backgroundColor)
        };
    }
    const bgColors = getBGColors();
    const btnStyles = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (_a = props.style) === null || _a === void 0 ? void 0 : _a.container), { backgroundColor: bgColors.defaultBackground, borderColor: props.defaultBackground || ((_c = (_b = props.style) === null || _b === void 0 ? void 0 : _b.container) === null || _c === void 0 ? void 0 : _c.borderColor) }), props.rounded && ((_d = props.style) === null || _d === void 0 ? void 0 : _d.rounded)), props.disabled && ((_e = props.style) === null || _e === void 0 ? void 0 : _e.disabled)), props.inactive && ((_f = props.style) === null || _f === void 0 ? void 0 : _f.inactive));
    const btnTextStyles = [
        (_g = props.style) === null || _g === void 0 ? void 0 : _g.text,
        { color: props.defaultBackground || ((_j = (_h = props.style) === null || _h === void 0 ? void 0 : _h.text) === null || _j === void 0 ? void 0 : _j.color) },
        isHovered && !props.disabled && ((_k = props.style) === null || _k === void 0 ? void 0 : _k.hoverText),
        props.textStyle,
        props.rounded && ((_l = props.style) === null || _l === void 0 ? void 0 : _l.roundedText),
        props.inactive && ((_m = props.style) === null || _m === void 0 ? void 0 : _m.inactiveText)
    ];
    let color = (_p = (_o = props.style) === null || _o === void 0 ? void 0 : _o.text) === null || _p === void 0 ? void 0 : _p.color;
    if (isHovered && !props.disabled) {
        color = (_r = (_q = props.style) === null || _q === void 0 ? void 0 : _q.hoverText) === null || _r === void 0 ? void 0 : _r.color;
    }
    if (props.rounded) {
        color = (_t = (_s = props.style) === null || _s === void 0 ? void 0 : _s.roundedText) === null || _t === void 0 ? void 0 : _t.color;
    }
    if (props.inactive) {
        color = (_v = (_u = props.style) === null || _u === void 0 ? void 0 : _u.inactiveText) === null || _v === void 0 ? void 0 : _v.color;
    }
    return _jsx(BaseButtonView, Object.assign({}, props, { style: undefined, containerStyle: btnStyles, textStyle: btnTextStyles, color: props.color || color, onHover: onHover, onBlur: onBlur, disabled: props.disabled || props.inactive, defaultBackground: bgColors.defaultBackground, hoverBackground: bgColors.hoverBackground, pressBackground: bgColors.pressBackground, inactiveBackground: bgColors.inactiveBackground, disableBackground: bgColors.disableBackground }));
});
